import React from 'react';
import { STRIPE_PUBLIC_KEY } from 'constants/stripe';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import Content from './Content';

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

type Props = {
    open?: boolean;
    onClose?: () => void;
    onUpdatePaymentInfo?: () => void;
    hideBank?: boolean;
};

export default function Wrapper({ open, onClose, onUpdatePaymentInfo, hideBank }: Props) {
    return (
        <Elements stripe={stripePromise}>
            <Content
                open={open}
                onClose={onClose}
                onUpdatePaymentInfo={onUpdatePaymentInfo}
                hideBank={hideBank}
            />
        </Elements>
    );
}
